import React from 'react'
import PropTypes from 'prop-types'

import * as styles from './styles'

const PopupComponent = ({
  children,
  isOpen,
  renderTrigger,
  onMouseEnter,
  onMouseLeave,
  useAsTooltip,
}) => {
  return (
    <div
      css={styles.wrapper}
      onMouseLeave={!useAsTooltip ? onMouseLeave : undefined}
    >
      <div
        onMouseEnter={onMouseEnter}
        onTouchStart={onMouseEnter}
        onMouseLeave={useAsTooltip ? onMouseLeave : undefined}
      >
        {renderTrigger?.(isOpen)}
      </div>
      <div css={[styles.content, isOpen && styles.visible]}>{children}</div>
    </div>
  )
}
// TODO: Check popup position
PopupComponent.propTypes = {
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  children: PropTypes.node.isRequired,
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  isOpen: PropTypes.bool,
  renderTrigger: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  useAsTooltip: PropTypes.bool,
}

export default PopupComponent
